import angular from 'angular';
import { getRedirectUrlPath } from '../actions/page';
import {
  retailerSettingsService,
  blindReturnSidebarService,
  blindRepairSidebar,
  returnMethodSidebar,
  returnReasonSidebar,
  repairSidebar,
} from '../services';
import { store } from '../store';

angular.module('LoginPageController', []).controller('LoginPageController', [
  '$rootScope',
  '$scope',
  '$location',
  ($rootScope, $scope, $location) => {
    $rootScope.pageClass = 'validate-page';
    const settings = retailerSettingsService.getSettings();
    const { page: { isSimpleReturns } = {} } = store.getState();

    returnReasonSidebar.actions.resetSidebar();
    returnMethodSidebar.resetSidebar();

    if (settings.blindReturnConfig) {
      blindReturnSidebarService.actions.resetSidebar();
    }

    if (settings.repairsConfig) {
      repairSidebar.actions.resetSidebar();
    }

    if (settings.blindRepairsConfig) {
      blindRepairSidebar.actions.resetSidebar();
    }

    if (isSimpleReturns) {
      blindReturnSidebarService.actions.resetSavedItems();
    }

    $scope.toStep1 = () => {
      $location.path(store.dispatch(getRedirectUrlPath('step-1')));
    };
  },
]);
